<template>

  <img src="/static/img/header.png" style="margin:-36px 0px 37px -27px;width: 105%;" class="bnr" />

  <div class="row">
    <div class="col-md-12">
      <div class="authenticate">
        <h2 style="font-weight: initial;background: #202e6d; color: white;text-transform:initial;">Register</h2>
        <div class="wrap-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="account-box">
                <div id="register">
                  <div style="margin-bottom:20px;">

                  <!-- USER fields -->
                    <div class='form-group'>
                      <label style="font-weight:initial;">Name</label>
                      <input
                        type="text"
                        name="name"
                        v-model="input.name"
                        placeholder="Name"
                        class="form-control"
                      />
                    </div>

                    <div class='form-group'>
                      <label style="font-weight:initial;">Email</label>
                      <input
                        type="email"
                        name="email"
                        v-model="input.email"
                        placeholder="Email"
                        class="form-control"
                      />
                    </div>

                    <div class='form-group'>
                      <label style="font-weight:initial;">Username</label>
                      <input
                        type="text"
                        name="username"
                        v-model="input.username"
                        placeholder="Username"
                        class="form-control"
                      />
                    </div>

                    <div class='form-group'>
                      <label style="font-weight:initial;">Password</label>
                      <input
                        type="password"
                        name="password"
                        v-model="input.password"
                        placeholder="Password"
                        class="form-control"
                      />
                    </div>
                    <div class='form-group'>
                      <label style="font-weight:initial;">Confirm password</label>
                      <input
                        type="password"
                        name="confirmPassword"
                        v-model="input.confirmPassword"
                        placeholder="Confirm Password"
                        class="form-control"
                      />
                    </div>
                  <!-- END USER fields -->

                  <!-- SITE fields -->
                  <div class='form-group'>
                    <label style="font-weight:initial;">Site Name</label>
                    <input
                      type="text"
                      name="siteName"
                      v-model="input.siteName"
                      placeholder="Site Name"
                      class="form-control"
                    />
                  </div>
                  <!-- END SITE fields -->

                  </div>
                  <div class="">
                    <div class="" style="text-align: right;">
                      <button type="button" v-on:click="register()" class=""
                        style="text-transform: uppercase; width: 100px; height: 40px; color: white; background: #202e6d; outline: none; border: none; margin-bottom: 10px;"
                      >Register</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .authenticate .wrap-fluid {
    margin-left: 0px !important;
  }
</style>

<script>
import {
  Sites as SiteActions,
  App as AppActions,
  User as UserActions,
} from "vx/actions";
import Alert from "utils/alert";
import { config } from "../../config";

export default {
  name: "Register",
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
    };
  },

  vuex: {
    actions: {
      setTitle: AppActions.title,
      selectSite: SiteActions.select,
      authenticateLocally: UserActions.authenticateLocally,
      registerUser: UserActions.register
    },
  },

  ready() {
    this.setTitle("Register");
  },

  methods: {
		gotoSiteSelection() {
      this.$router.go({ name: "site-selection.index" });
    },
    isEmptyInput(inputValue, message){

      var result = typeof inputValue === "undefined" || inputValue === null || inputValue === "";

      if(result){
        this.fireValidationError(message);
      }

      return result;
    },
    fireValidationError(message){
      this.$dispatch('loaded');
      Alert.error({
        title: "Error!",
        text: message,
      });
    },
    register() {
      this.$dispatch('loading');

      if(this.isEmptyInput(this.input.name, "Please enter a name!")
        || this.isEmptyInput(this.input.email, "Please enter an email!")
        || this.isEmptyInput(this.input.username, "Please enter a username!")
        || this.isEmptyInput(this.input.password, "Please enter a password!")
        || this.isEmptyInput(this.input.confirmPassword, "Please confirm your password!")
        || this.isEmptyInput(this.input.siteName, "Please enter a Site name!")){
        return;
      }

      if(this.input.password !== this.input.confirmPassword){
        this.fireValidationError("The passwords provided do not match!");
        return;
      }

      this.registerUser(this.input.name, this.input.email, this.input.username, this.input.password, this.input.siteName).then(
        (response) => {
          this.$dispatch('loaded');
          this.$router.go({ name: "login" });
          Alert.confirm({title: "Please log in to continue", type: "success", confirmButtonColor: '#202e6d', showCancelButton: false, confirmButtonText: "Login"});
        },
        (response) => {
          this.$dispatch('loaded');
          let message = response.body.message;
          Alert.error({ title: "Error!", text: message });
        }
      );
    }
  },
};
</script>


// WEBPACK FOOTER //
// register.vue?95edfae4